import { render } from "./filter-color-wheel.vue?vue&type=template&id=cf9ea26c&scoped=true"
import script from "./filter-color-wheel.vue?vue&type=script&lang=js"
export * from "./filter-color-wheel.vue?vue&type=script&lang=js"

import "./filter-color-wheel.vue?vue&type=style&index=0&id=cf9ea26c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf9ea26c"]])

export default __exports__